<template>
    <DModal
        is-big
        :title="__('tools.fulfillment.request_details')"
        :show="showModal"
        @close="closeModal"
    >
        <DCard>
            <DCardBody>
                <DRow>
                    <DCol>
                        <span class="fw-bold">{{ __('tools.fulfillment.module') }}:</span>
                        <span>{{ request.filter }}</span>
                    </DCol>
                    <DCol>
                        <span class="fw-bold">{{ __('tools.fulfillment.customer') }}:</span>
                        <span v-if="request.job_reference.customer.company">{{ request.job_reference.customer.company }}</span>
                        <span v-else>{{ request.job_reference.customer.firstname }} {{ request.job_reference.customer.lastname }}</span>
                        <span>({{ request.job_reference.customer.id }})</span>
                    </DCol>
                    <DCol>
                        <span class="fw-bold">{{ __('tools.fulfillment.created_at') }}:</span>
                        <span>{{ toDateTimeString(request.created_at) }}</span>
                    </DCol>
                    <DCol>
                        <span class="fw-bold">{{ __('tools.fulfillment.status') }}:</span>
                        <span>{{ __('tools.fulfillment.status_' + request.status) }}</span>
                    </DCol>
                </DRow>
                <DRow>
                    <DCol>
                        <span class="fw-bold">{{ __('tools.fulfillment.action') }}:</span>
                        <span>{{ request.action.name }}</span>
                    </DCol>
                    <DCol>
                        <span class="fw-bold">{{ __('tools.fulfillment.contract') }}:</span>
                        <span>{{ request.job_reference.external_id }} ({{ request.job_reference.id }})</span>
                    </DCol>
                    <DCol>
                        <span class="fw-bold">{{ __('tools.fulfillment.updated_at') }}:</span>
                        <span>{{ toDateTimeString(request.updated_at) }}</span>
                    </DCol>
                    <DCol>
                        <span class="fw-bold">{{ __('tools.fulfillment.attempts') }}:</span>
                        <!--
                            This modal shows the count and lists nothing, so archive mode ships
                            tries_total alone -- no attempts inline, no fetch on open. Live rows
                            carry no tries_total and fall through to their eager-loaded attempts.
                        -->
                        <span>{{ request.tries_total ?? request.tries?.length ?? 0 }}</span>
                    </DCol>
                </DRow>
            </DCardBody>
        </DCard>
    </DModal>
</template>

<script>
import moment from 'moment/moment'

export default {
    name: 'DomainRequestDetailsModal',
    props: {
        request: {
            type: Object,
            default: () => { return {} }
        },
        showModal: {
            type: Boolean,
            default: false
        }
    },
    emits: ['close-modal'],
    data () {
        return {
        }
    },
    methods: {
        toDateTimeString (value) {
            return moment(value).format('YYYY-MM-DD')
        },
        closeModal () {
            this.$emit('close-modal')
        }
    }

}
</script>

<style scoped>
</style>
